import qs from 'qs'

import { TypesRequests, CourseTypes } from 'enum'
import api from '..'

interface Params {
  type: TypesRequests
  typeCourse?: CourseTypes | null
}

const download = ({ type, typeCourse }: Params) => {
  return api
    .get<string>(
      `all_course_requests/download?${qs.stringify({
        type,
        type_course: typeCourse,
      })}`
    )
    .then(({ data }) => {
      return data
    })
}

export default download
